export const RETURNS_CHANGE_FILTERS = 'RETURNS_CHANGE_FILTERS';

export const returnsChangeFilters = (statusViewId, appliedFilters) => ({
  type: RETURNS_CHANGE_FILTERS,
  statusViewId,
  appliedFilters,
});
